import { type SanityFrameBuilderType } from '@frame-builder/data/sanity/queries/types'
import { getFrameBuilderPrice, getFrameBuilderPriceWithDiscount } from './price'
import {
  getStateFrameArea,
  getStateFramePerimeter,
  getStateFrameSize,
} from './size'
import {
  type FrameBuilderConfigurationWithLimits,
  type FrameBuilderState,
} from './types'

/**
 * Calculates frame builder price based on frame state.
 */
export const getStatePrice = (
  frameBuilderType: SanityFrameBuilderType,
  frameBuilderConfiguration: FrameBuilderConfigurationWithLimits,
  state: FrameBuilderState,
) => {
  const frameSize = getStateFrameSize(state)
  const frameArea = getStateFrameArea(state)
  const framePerimeter = getStateFramePerimeter(state)

  const profileTexture = frameBuilderConfiguration.profileTextures.find(
    (profileTexture) => {
      return (
        profileTexture.profile?._ref === state.profile?._id &&
        profileTexture.texture?._ref === state.texture?._id
      )
    },
  )

  return getFrameBuilderPrice(
    frameBuilderType,
    frameBuilderConfiguration.servicePrices,
    frameSize[0],
    frameSize[1],
    frameArea,
    framePerimeter,
    state.profile,
    profileTexture,
    state.passepartout.color,
    state.glass,
    state.spacerSize,
  )
}

/**
 * Calculates frame builder price with discounts based on frame state.
 */
export const getStatePriceWithDiscount = (
  frameBuilderType: SanityFrameBuilderType,
  frameBuilderConfiguration: FrameBuilderConfigurationWithLimits,
  state: FrameBuilderState,
) => {
  const frameSize = getStateFrameSize(state)
  const frameArea = getStateFrameArea(state)
  const framePerimeter = getStateFramePerimeter(state)

  const profileTexture = frameBuilderConfiguration.profileTextures.find(
    (profileTexture) => {
      return (
        profileTexture.profile?._ref === state.profile?._id &&
        profileTexture.texture?._ref === state.texture?._id
      )
    },
  )

  return getFrameBuilderPriceWithDiscount(
    frameBuilderType,
    frameBuilderConfiguration.servicePrices,
    frameSize[0],
    frameSize[1],
    frameArea,
    framePerimeter,
    state.profile,
    profileTexture,
    state.passepartout.color,
    state.glass,
    state.spacerSize,
  )
}
